var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyaltyTier3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 60 60"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6F5CFF",
  d: "M52.652 0h-45.3L.002 7.35v45.3L7.352 60h45.3l7.35-7.35V7.35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.209 48.703c-7.285 0-12.658-4.288-12.968-11.625h6.871c.207 3.668 2.273 6.252 6.097 6.252 3.513 0 6.148-1.912 6.148-5.942 0-2.893-2.48-5.218-6.717-5.218h-2.583v-5.373h2.583c3.565 0 5.683-1.964 5.683-5.219 0-3.306-2.376-4.908-5.321-4.908-3.203 0-5.477 2.325-5.683 5.839H17.86c.31-7.44 5.529-11.212 12.142-11.212 7.181 0 11.728 3.772 11.728 9.765 0 4.288-2.583 6.768-6.252 7.905 3.875.62 7.285 3.771 7.285 8.731 0 6.975-4.701 11.005-12.554 11.005"
})));
export default SvgLoyaltyTier3;